"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import type { Job } from "~/types/job";
import { TrackJobad } from "./nodes";
import { observeElements } from "./observe-elements";
export function JobadTracking(t0) {
  const $ = _c(3);
  const {
    job
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== job) {
    t2 = <TrackJobad job={job} />;
    $[1] = job;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp() {
  const unobserveElements = observeElements();
  return () => {
    if (unobserveElements) {
      unobserveElements();
    }
  };
}